import initialState from './initialState';
import { reducer as fetchDisciplineReducer } from './fetchDiscipline';
import { reducer as fetchBannerListReducer } from './fetchBannerList';
import { reducer as fetchCourseLookInfoReducer } from './fetchCourseLookInfo';
import { reducer as fetchMessageDataReducer } from './fetchMessageData';
import { reducer as fetchHomeModelListReducer } from './fetchHomeModelList';
import { reducer as fetchMenuListReducer } from './fetchMenuList';
import { reducer as fetchGetStuInfoBySIdReducer } from './fetchGetStuInfoBySId';
import { reducer as fetchCreatePromoterReducer } from './fetchCreatePromoter';
import { reducer as fetchStudentPublicListReducer } from './fetchStudentPublicList';
import { reducer as fetchGetExperienceClassReducer } from './fetchGetExperienceClass';
import { reducer as fetchGetHomeHotRecommendReducer } from './fetchGetHomeHotRecommend';
import { reducer as fetchGetFreeClassificationReducer } from './fetchGetFreeClassification';
import { reducer as fetchGetShopReducer } from './fetchGetShop';

const reducers = [
  fetchDisciplineReducer,
  fetchBannerListReducer,
  fetchCourseLookInfoReducer,
  fetchMessageDataReducer,
  fetchHomeModelListReducer,
  fetchMenuListReducer,
  fetchGetStuInfoBySIdReducer,
  fetchCreatePromoterReducer,
  fetchStudentPublicListReducer,
  fetchGetExperienceClassReducer,
  fetchGetHomeHotRecommendReducer,
  fetchGetFreeClassificationReducer,
  fetchGetShopReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/home/redux/reducer.js